import addDays from 'date-fns/addDays';
import format from 'date-fns/format';
import set from 'date-fns/set';
import startOfWeek from 'date-fns/startOfWeek';

import { OPERATIONS } from '../constants';
import { type Operation, type OperationIds, type TimeRestriction } from '../types';

export const getOperationName = (id: OperationIds): Operation => {
	const operation = OPERATIONS.find((operation) => operation.id === id);
	return operation?.name as Operation;
};

export const getDays = () => {
	const firstDOW = startOfWeek(new Date(), {
		weekStartsOn: 0,
	});

	const weekDays = Array.from(Array(7)).map((e, i) => ({
		label: format(addDays(firstDOW, i), 'EEE'),
		value: (i % 7) + 1,
	}));

	return weekDays as {
		label: string;
		value: 1 | 2 | 3 | 4 | 5 | 6 | 7;
	}[];
};

export const formatRestriction = (timeInterval: TimeRestriction) => {
	const days = getDays();

	const startDay = days.find((day) => day.value === timeInterval.startDay);
	const endDay = days.find((day) => day.value === timeInterval.endDay);

	const startTime = format(
		set(new Date(), {
			hours: timeInterval.startHour,
			minutes: timeInterval.startMinute,
		}),
		'p',
	);

	const endTime = format(
		set(new Date(), {
			hours: timeInterval.endHour,
			minutes: timeInterval.endMinute,
		}),
		'p',
	);

	if (startDay && endDay) {
		const formattedTime = `${startDay.label} ${startTime} - ${endDay.label} ${endTime}`;

		return formattedTime;
	}

	const formattedTime = `${startTime} - ${endTime}`;

	return formattedTime;
};
